import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import PublicLayout from '../../../layouts/public';
import { lzGetAssetUrl, lzShowSuccessMessage } from '../../../../services/LzUtils';
import ImgLogo from '../../../../assets/images/logo.png';
import ImgLzLogo from '../../../../assets/images/lz-logo.png';
import { Link } from 'react-router-dom';
import { lzCallApi } from '../../../../services/LzApiService';

class ForgotPasswordScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            model: {
                email: props.match?.params?.email || '',
            },
        };
    }

    handleInputChange = (name, value) => {
        this.setState({ [name]: value });
    };

    onSubmit(evt) {
        evt.preventDefault();
        this.callForgotPwdApi();
    }

    async callForgotPwdApi() {
        const { history } = this.props;
        const { model } = this.state;

        // Make the api call and get processed data
        const data = await lzCallApi('forgot-pwd', model, 'post');

        // Validate data and redirect
        if (data) {
            history.push('/user/reset-password/' + model.email);
            lzShowSuccessMessage(data);
        }
    }

    render() {
        const { model } = this.state;

        return (
            <PublicLayout>
                <div className="full-page-form">
                    <Card className="card">
                        <div className="half-form bg-signin">
                            <form noValidate autoComplete="off" onSubmit={(evt) => this.onSubmit(evt)}>
                                <img src={lzGetAssetUrl(ImgLogo)} alt="Logo" className="logo" />

                                <h2>Forgot Password</h2>

                                <FormGroup row>
                                    <TextField fullWidth variant="outlined" label="Email Address" helperText="enter your email address"
                                        value={model.email} onChange={(ev) => this.setState({ model: Object.assign({}, model, { email: ev.target.value }) })}
                                    />
                                </FormGroup>

                                <FormGroup row>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Button type="submit" variant="contained" color="primary">Submit</Button>
                                        </Grid>
                                        <Grid item xs={9} style={{ textAlign: 'right' }}>
                                            <Link to={'/user/reset-password/' + model.email}>Already received a reset code?</Link>
                                        </Grid>
                                    </Grid>
                                </FormGroup>

                                <FormGroup row>
                                    <Grid container>
                                        <Grid item xs={12} style={{ textAlign: 'right', marginTop: 12 }}>
                                            <Link to={'/user/login'}>Click here to go to Sign-in page.</Link>
                                        </Grid>
                                    </Grid>
                                </FormGroup>
                            </form>
                        </div>
                    </Card>
                    <a href="https://logic-zone.net/?ref=services.2adata" target="_blank" rel="noreferrer" className="powered-by">
                        Powered by :
                        <img src={lzGetAssetUrl(ImgLzLogo)} alt="Logic-Zone" />
                    </a>
                </div>
            </PublicLayout>
        );
    }

}

export default ForgotPasswordScreen;
